import React, { useState, useEffect } from "react";
import {
  EditPageContainer,
  Page,
  withServerErrors,
  required,
} from "components/common";
import { FormGroup, InputGroup, SaveButton } from "components/common/Forms";
import GetBack from "components/refactoring/BackButton";
import { compose, withState, withHandlers } from "recompose";
import { LocalForm, Control, actions } from "react-redux-form";
import { useHistory } from "react-router-dom";
import { Col, Row } from "reactstrap";
import Multiselect from "multiselect-react-dropdown";
import { colStyle } from "pages/Core/CoreComponents";


const roles = [
  { value: 'Subscriber', label: "Subscriber" },
  { value: 'User', label: "User" },
  { value: 'Superuser', label: "Superuser" },
]

export const Edit = ({
  t,
  mode,
  item,
  form,
  setDispatch,
  onSubmit: onSubmitProp,
  onUpdate,
  onChange,
  readOnly,
  client,
  dispatch,
  change
}) => { 
  const [groups, setGroups] = useState([])
  const [organisations, setOrganisations] = useState([])

  const [recipients, setRecipients] = useState([])

  const history = useHistory();

  async function onSubmit(...args) { 
    await change('recipients', recipients)

    await onSubmitProp(...args);

    setTimeout(() => {
      history.push(`/announcements`);
    }, 500);
  }

  const fetchData = async () => {
    const groups = await client.get("authorization/group");
    const organisations = await client.get("connected_organisations");
    
    setGroups(groups?.data)
    setOrganisations(organisations?.data)
  }

  useEffect(() => {
    fetchData();

    if (item?.recipients) {
      let recipients = {
        groups: [],
        connected_organisations: [],
        roles: [],
      }

      let existingGroups = []
      let existingOrganisations = []
      let existingRoles = []

      item.recipients.forEach((recipient) => {
        if (recipient.group) { 
          if (!existingGroups.includes(recipient.group)) {
            recipients.groups.push(recipient.group_data)
            existingGroups.push(recipient.group)
          }
        }

        if (recipient.connected_organisation) { 
          if (!existingOrganisations.includes(recipient.connected_organisation)) {
            recipients.connected_organisations.push(recipient.connected_organisation_data)
            existingOrganisations.push(recipient.connected_organisation)
          }
        }

        if (recipient.role) { 
          if (!existingRoles.includes(recipient.role)) {
            recipients.roles.push({ value: recipient.role, label: recipient.role })
            existingRoles.push(recipient.role)
          }
        }
      })

      setRecipients(recipients)
    }
  }, []);

  const multiSelectStyle = {
    chips: { background: '#72B566' },
  }

  const handleSelect = (selectedList, field) => { 
    setRecipients({ ...recipients, [field]: selectedList })
  }

  const handleRemove = (selectedList, field) => { 
    setRecipients({ ...recipients, [field]: selectedList })
  }

  return (
    <Page title={`${mode} Announcement`}>
      <GetBack styleClass="my-2"/>
      <LocalForm
        initialState={item}
        onSubmit={onSubmit}
        getDispatch={setDispatch}
        onUpdate={onUpdate}
        onChange={onChange}
      >
        <div className="d-flex justify-content-start">
          <Row>
            <Col {...colStyle}>
              <FormGroup label="Title *" model=".title">
                <Control.text model=".title" autoComplete="off" />
              </FormGroup>
            </Col>

            <Col {...colStyle}>
              <FormGroup label="Message *" model=".message">
                  <Control.textarea model=".message" autoComplete="off" />
              </FormGroup>
            </Col>
      
            <Col {...colStyle}>
              <FormGroup addControlClass={false} label="Group" model=".groups">
                <Multiselect
                  options={groups} // Options to display in the dropdown
                  selectedValues={recipients.groups || []} // Preselected value to persist in dropdown
                  onSelect={(selectedList) => handleSelect(selectedList, 'groups')} // Function will trigger on select event
                  onRemove={(selectedList) => handleRemove(selectedList, 'groups')} // Function will trigger on remove event
                  displayValue="name" // Property name to display in the dropdown options
                  avoidHighlightFirstOption
                  showCheckbox={true}
                  style={multiSelectStyle}
                  placeholder={t("Select")}
                  emptyRecordMsg={t('No options available')}
                />
              </FormGroup>
            </Col>

            <Col {...colStyle}>
              <FormGroup addControlClass={false} label="Role" model=".roles">
                <Multiselect
                  options={roles} // Options to display in the dropdown
                  selectedValues={recipients.roles ||[]} // Preselected value to persist in dropdown
                  onSelect={(selectedList) => handleSelect(selectedList, 'roles')} // Function will trigger on select event
                  onRemove={(selectedList) => handleRemove(selectedList, 'roles')} // Function will trigger on remove event
                  displayValue="label" // Property name to display in the dropdown options
                  avoidHighlightFirstOption
                  showCheckbox={true}
                  style={multiSelectStyle}
                  placeholder={t("Select")}
                  emptyRecordMsg={t('No options available')}
                />
              </FormGroup>
            </Col>

            <Col {...colStyle}>
              <FormGroup addControlClass={false} label="Organisation" model=".connected_organisations">
                <Multiselect
                  options={organisations} // Options to display in the dropdown
                  selectedValues={recipients.connected_organisations || []} // Preselected value to persist in dropdown
                  onSelect={(selectedList) => handleSelect(selectedList, 'connected_organisations')} // Function will trigger on select event
                  onRemove={(selectedList) => handleRemove(selectedList, 'connected_organisations')} // Function will trigger on remove event
                  displayValue="name" // Property name to display in the dropdown options
                  avoidHighlightFirstOption
                  showCheckbox={true}
                  style={multiSelectStyle}
                  placeholder={t("Select")}
                  emptyRecordMsg={t('No options available')}
                />
              </FormGroup>
            </Col>
          </Row>

        </div>

        <div className="my-3 d-flex justify-content-start">
          <SaveButton className="px-3 m-0" form={form} hidden={readOnly}>Save</SaveButton>
        </div>
      </LocalForm>
    </Page>
  );
};

const enhance = compose(
  withServerErrors(),
  EditPageContainer({
    url: "notifications",
  }),
  withState("serverErrors", "setServerErrors", {}),
  withState("redirectUrl", "setRedirectUrl", null),

  withHandlers({
  }),
);

export default enhance(Edit);
